module.exports = __webpack_public_path__ + "img/header-people.7a12c036.png";